export default __webpack_public_path__ + "static/media/singpass-logo.d32b75c6.svg";